window.DOLOBITES_PRICING = (() => {
  const getConfig = () => window.DOLOBITES_BOOKING_CONFIG;

  const formatCurrency = (amount, showDecimals = false) => {
    const config = getConfig();

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: config?.currency || 'USD',
      minimumFractionDigits: showDecimals ? 2 : 0,
      maximumFractionDigits: showDecimals ? 2 : 0
    }).format(Number(amount) || 0);
  };

  const getRecommendedPackage = (guests) => {
    const config = getConfig();

    if (!config?.packages) return null;

    return (
      config.packages.find(
        (packageItem) => guests <= packageItem.maxGuests
      ) || null
    );
  };

  const getPremiumFlavoursTotal = (selectedFlavours = []) => {
    return selectedFlavours.reduce(
      (total, flavour) => total + (Number(flavour.extraPrice) || 0),
      0
    );
  };

  const getExtraPrice = (extra, guests) => {
    if (!extra) return 0;

    if (extra.pricingType === 'perGuest') {
      return (Number(extra.price) || 0) * guests;
    }

    return Number(extra.price) || 0;
  };

  const getExtrasTotal = (selectedExtras = [], guests = 0) => {
    return selectedExtras.reduce(
      (total, extra) => total + getExtraPrice(extra, guests),
      0
    );
  };

  const getTravelFee = (distanceMiles) => {
    const config = getConfig();
    const distance = Number(distanceMiles);

    if (!Number.isFinite(distance) || distance < 0) {
      return 0;
    }

    if (distance > config.maximumServiceDistanceMiles) {
      return null;
    }

    const matchingBand = config.travelBands.find(
      (band) =>
        distance >= band.minMiles &&
        distance <= band.maxMiles
    );

    return matchingBand ? matchingBand.fee : 0;
  };

  const calculateTotals = ({
    selectedPackage,
    selectedFlavours = [],
    selectedExtras = [],
    guests = 0,
    travelFee = 0
  }) => {
    const config = getConfig();

    const packagePrice = Number(selectedPackage?.price) || 0;
    const premiumFlavoursTotal =
      getPremiumFlavoursTotal(selectedFlavours);
    const extrasTotal = getExtrasTotal(selectedExtras, guests);
    const validTravelFee = Number(travelFee) || 0;

    const total =
      packagePrice +
      premiumFlavoursTotal +
      extrasTotal +
      validTravelFee;

    const depositPercentage =
      Number(config?.depositPercentage) || 50;

    const deposit = total * (depositPercentage / 100);
    const balance = total - deposit;

    return {
      packagePrice,
      premiumFlavoursTotal,
      extrasTotal,
      travelFee: validTravelFee,
      total,
      deposit,
      balance
    };
  };

  return {
    formatCurrency,
    getRecommendedPackage,
    getPremiumFlavoursTotal,
    getExtraPrice,
    getExtrasTotal,
    getTravelFee,
    calculateTotals
  };
})();